/**
 * Destination IDs eligible for the low-view destinations sales CTR ranking experiment.
 * Source: OSS-4134 criteria (<=5 non-flash offers with >1000 views), regenerated 2026-07-15
 * via shared/scripts/generate-low-view-destinations.py -- ranked by 90-day search volume,
 * verified against the live /api/search/v1/light endpoint.
 */
export const LOW_VIEW_DESTINATIONS_SALES_CTR_RANKING_DESTINATION_IDS: ReadonlySet<string> = new Set([
  'le_ff7aa1f9b4062bfee0f99a0453506f1b', // Bangkok
  'le_735b90b4568125ed6c3f678819b6e058', // Greece
  'le_66ff0e7c30438d414ff0a941b759f114', // London
  'le_3fb451ca2e89b3a13095b059d8705b15', // Hamilton Island
  'le_12767faf1bf8cafc7594430586c558c2', // Europe
  'le_cb3f7087c987ceff5b306d4ff89f5db6', // Paris
  'le_a9c53c0f1fe23357e3ba6a078ddb0990', // Uluwatu
  'le_5878a7ab84fb43402106c575658472fa', // Sri Lanka
  'le_464adf7b911508701f4c4e70eab19a6e', // Auckland
  'le_2b24d495052a8ce66358eb576b8912c8', // Philippines
  'le_4371d2566cbf4eb16e1cda1ce268c63c', // Blue Mountains
  'le_3b8592097e6f88f678a8983da586251d', // Byron Bay
  'le_5f169380fd43eadac8a9f1423aaa9ac8', // Canberra
  'le_9eaae23a6eaea01a1d6111023c69f199', // Ho Chi Minh City
  'le_28dd2c7955ce926456240b2ff0100bde', // Hong Kong SAR
  'le_425f0cea87a40c5a8860e3db7c918c4e', // Canggu
  'le_93db85ed909c13838ff95ccfa94cebd9', // Italy
  'le_f243f5a39d3b7ef531788ff07ea1ca58', // Kuala Lumpur
  'le_7e7757b1e12abcb736ab9a754ffb617a', // Spain
  'le_3f08f0e6992e8d712984a799e6681209', // Darwin
  'le_c434daa77ef5bff49159bb7305963f01', // Kata
  'le_289dff07669d7a23de0ef88d2f7129e7', // New York
  'le_832d851fd4d8851affa0b77077f5b4d6', // Rome
  'le_eb160de1de89d9058fcb0b968dbbbd68', // Mexico
  'le_b536d75d9b756802546437b33b09b5e8', // Krabi
  'le_77a4a0e5a3bdfee80c9eff1420165977', // Mornington Peninsula
  'le_2b44928ae11fb9384c4cf38708677c48', // Mauritius
  'le_3cbc4af26e4af14e7d661382d2678fff', // Barcelona
  'le_e5d100c6a4cfabdcbc5d6b9841de87d9', // Airlie Beach
  'le_61caba6de422bfe3e57b8dfa6cea0258', // Crete
  'le_83fba92646fd4b0c7d8995bf405214c8', // Broome
  'le_cfecdb276f634854f3ef915e2e980c31', // United Kingdom
  'le_5147a59412059410bc45383e9efbe176', // Laguna
  'le_b78b33d227b43e4dbdee113e2ab95e8e', // Dubai
  'le_0f34314d2dd0c1b9311cb8f40eb4f255', // Lombok
  'le_0663a4ddceacb40b095eda264a85f15c', // Hanoi
  'le_838ebb25ec2c4b61547262c446da2b6a', // Santorini
  'le_edab64948fd0fb98f4662e74826352c2', // Mooloolaba
  'le_2a79ea27c279e471f4d180b08d62b00a', // Samoa
  'le_2dddca165ef38c731e7cce6069107fa6', // Bowral
  'le_625580883b641361b9b72f32dc85dbce', // Aitutaki
  'le_e4f9f1a6a6193f7100fc69a9abe3fc27', // Margaret River
  'le_f964e87e2c42208253412904eec37214', // Chiang Mai
  'le_140f6969d5213fd0ece03148e62e461e', // Seychelles
  'le_1e15efc3fac4ba31daa6f91082c97e97', // Christchurch
  'le_e6fd3b368ff273183a74d471a141d7c3', // Yarra Valley
  'le_6fc671d6a9900b46f5b5389ea2188e59', // Mallorca Island
  'le_c7a67e4450aa307b8c3991da5fe94bd0', // Bora Bora
  'le_dd6cfa36ca5f428a6c9824630d3a8a96', // Osaka
  'le_8701b6eda0e8f334b30b4488214bbf1e', // Cancun
  'le_5186b5eb83798a2a7a0bec02e7e95c5d', // Port Stephens
  'le_4e8a0fcae374fd3909f64555cdea95a1', // Daylesford
  'le_c98e367e46aa4e7c4d6823b021865936', // Kyoto
  'le_2713c41ba82eb27554b627bbe991bc7a', // South Coast
  'le_2e7c768f8f48b4d6de838814d789b0bb', // Hua Hin
  'le_84254f05131de1561e62e5cf5153a3b9', // Seoul
  'le_43baa6762fa81bb43b39c62553b2970d', // Dubai Emirate
  'le_4c3b14ba89e6289b61eb1bb344e2c2cf', // Maui
  'le_342fdc93f26b8bb8fe3548a9188ea5d2', // Athens
  'le_045cf83ab0722e782cf72d14e44adf98', // Penang
  'le_02f039058bd48307e6f653a2005c9dd2', // Mykonos
  'le_1afa34a7f984eeabdbb0a7d494132ee5', // New Caledonia
  'le_b26457e8774dcf3bf66024f7600ee686', // Central Coast
  'le_a1f2f70f31cf6916b600f2a558c4f082', // Sardinia
  'le_1379719828be9ee6b08ca64edb818e2b', // Burleigh Heads
  'le_afcf8ed19482ebcf0c9b20bde2b56b7b', // Geelong
  'le_43fa7f58b7eac7ac872209342e62e8f1', // Corfu
  'le_1ada7faf229425b786d87f7d9d5d43f2', // New York
  'le_42b7cd3987c66a682bbbee7573bf6785', // Mai Khao
  'le_373ef50ce9c3f96bdd8b2f6e7e839b50', // Newcastle
  'le_7409387f1ebd52e28e7cf147dc22cb6e', // Sicily
  'le_324d1d5faac07d0c5ae13c2213b84ea9', // Las Vegas
  'le_570a90174cbbe07bda17a54f94f47637', // Phillip Island
  'le_079230e29195cac1ce62e737740797a0', // Los Angeles
  'le_ef9e7160514b136fca49362a95d52977', // Nha Trang
  'le_a5a61717dddc3501cfdf7a4e22d7dbaa', // Lord Howe Island
  'le_093f65e080a295f8076b1c5722a46aa2', // France
  'le_5b8abd68981b66b960aaf87e81ef49b3', // Pattaya
  'le_8d5e957f297893487bd98fa830fa6413', // Portugal
  'le_ad110b81cf05db07b4fdaa971d46c56d', // Tahiti
  'le_4c6515356f214aa275e07ddbbd922a5e', // Wollongong
  'le_d66949480296c2957d4541919879f361', // Kangaroo Island
  'le_53851b14dc1915e729390e7d38bc7654', // Algarve
  'le_3a029f04d76d32e79367c4b3255dda4d', // Florence
  'le_f033ab37c30201f73f142449d037028d', // India
  'le_05c690755465e8723c8d9ee8d5b6f486', // Barossa Valley
  'le_698d51a19d8a121ce581499d7b701668', // Malta
  'le_1cf91418caeda6937be5e272547fe200', // Tuscany
  'le_e282d1cf59bc440f418e92b618e37e14', // Lorne
  'le_5c3cf0d87258ec2cd944ea87fc9260a1', // Rhodes
  'le_0651279f1f67b3dfd57a0fd8f0668bb2', // Coolangatta
  'le_22bbd93ccefbab19659fe6a72a7c990c', // Manhattan
  'le_55b762ca9d26b0b09725e7d662806862', // Shinjuku
  'le_7bcf5b2d63544b64edfe843df78afef2', // Vancouver
  'le_8e809411bbd25cac078ba595cc2922f8', // Torquay
  'le_a8b9081f7c011f43e2259f9c457a1d37', // Boracay Island
  'le_736508c51af06f80d18048c3a99d94c1', // Lake Como
  'le_2e378cea7a9a763222e0482db0dc9ee7', // Venice
  'le_568221292bd68ebdd821521ce60a8110', // England
  'le_f4b9ec30ad9f68f89b29639786cb62ef', // South Korea
  'le_69d9743b8a0dac625d2c82dde7a077e4', // Townsville
  'le_f69218cc2f5e86fc147c3038870fc493', // Cradle Mountain
  'le_23562198fd147e23311748e1e97b724c', // Port Macquarie
  'le_ba1ceaceb2db0e0462679cfc4a6ae170', // Goa
  'le_54ff9e9e3a2ec0300d4ce11261f5169f', // Lisbon
  'le_7eabe3a1649ffa2b3ff8c02ebfd5659f', // California
  'le_dd5bfdeb57f7c75d400de61e99d78e2e', // Ballarat
  'le_8ebf84a4954068cc2a998f04fb26fea6', // Southern Highlands
  'le_84bf68ea8e60ca1c6ea578742fc2b324', // Shanghai
  'le_3a2a7f625483caa9328624a976dc8527', // Kingscliff
  'le_d7bce4d8dbac13945471c343c4973ba3', // Caribbean
  'le_0ab922ba3e948387b4b2a85fcb83d194', // Zanzibar
  'le_7a55fb8503583f7451544623e3f75f93', // Busselton
  'le_7665028ffa6a8c9b52fd1b21c37e41e6', // Borneo
  'le_0cf05e5adbf5f3a64c72fb3d6a24758f', // Montenegro
  'le_f1a9435395997c4c05c1e979b78ead26', // Palawan
  'le_0a4703b5ee768403d6cf1f04b768def7', // Amsterdam
  'le_019cf615e71dc6ec778f64fb0022f3d9', // Launceston
  'le_7f39f8317fbdb1988ef4c628eba02591', // French Polynesia
  'le_c5f441cd5f43eb2f2c024e1f8b5d00cd', // Bendigo
  'le_8150c8232c40a27facde91222e859ead', // London City Centre
  'le_85dc4b985c0550b1f202694c615c42d2', // Amalfi Coast
  'le_0f33d9fe6955f349a9145dfb2203f0e4', // Sorrento
  'le_71ad16ad2c4d81f348082ff6c4b20768', // Coffs Harbour
  'le_f01722cf0682667d18119b2cdef492ad', // Edinburgh
  'le_c81e728d9d4c2f636f067f89cc14862c', // Albania
  'le_e4e3799f4cdb9f35b1df0099a3364edf', // Kamala
  'le_cd18715c3998f5e305b948ffc72cf765', // Madrid
  'le_683f12427fdfb5a0b8138fec58b9844f', // Hong Kong Island
  'le_e143c01e314f7b950daca31188cb5d0f', // Manly
  'le_cfd2b32e4caf5678c34b631f56c03686', // Marbella
  'le_732d6bb3074eefac3b2287d0bd8ef8fa', // Rotorua
  'le_3aaa3db6a8983226601cac5dde15a26b', // Fremantle
  'le_a5bfc9e07964f8dddeb95fc584cd965d', // China
  'le_c256df8aa62d7d94ff1a7c4ecf70245f', // Kangaroo Valley
  'le_6b50599607a730cc36ce5f163b729482', // Istanbul
  'le_4df9760910089ef7dd67573145de8745', // Magnetic Island
  'le_a0a080f42e6f13b3a2df133f073095dd', // Morocco
  'le_5c5bc7df3d37b2a7ea29e1b47b2bd4ab', // Sorrento
  'le_0c7ee90ac6e5920a9ab1ccf3c66fc9ab', // Southbank
  'le_fd87f0d4bde24eadae6f324b7d4c31a6', // Wellington
  'le_6bef88cb2019901d3e5d85435b60619d', // Mudgee
  'le_73c5930c3a59a6728f16cc5345fd8b6c', // Phi Phi Islands
  'le_c74d97b01eae257e44aa9d5bade97baf', // Barbados
  'le_6364d3f0f495b6ab9dcf8d3b5c6e0b01', // Cape Verde
  'le_17e62166fc8586dfa4d1bc0e1742c08b', // Croatia
  'le_c16a5320fa475530d9583c34fd356ef5', // Canada
  'le_7a135f50ded719a23dd2b829ff4eaf88', // Niseko
  'le_4c91676af7fe42293f8686dc898662e0', // Orlando
  'le_0b7a79dbe88be49a6ab94db074007f48', // Marrakech
  'le_b4cc02b6fd96dc538e79abf48132bb3c', // Karon
  'le_6afe49dcb36cc10aeab41ef4ed8ac72d', // Punta Cana
  'le_14ecb3e647f034724f0e2d004c51d6f0', // Porto
  'le_6cdd60ea0045eb7a6ec44c54d29ed402', // Turks and Caicos
  'le_4ecb679fd35dcfd0f0894c399590be1a', // Wānaka
  'le_86401d388d4865e45feb650e82440115', // Ao Nang
  'le_c44baba750f7f374513f284af2f83f86', // Nelson Bay
  'le_10c1e1b92a8e520493d88ae8a6ec4807', // Copenhagen
  'le_b90c46963248e6d7aab1e0f429743ca0', // Sabah
  'le_9461cce28ebe3e76fb4b931c35a169b0', // Antalya
  'le_ea9a635395384d316bef4e9044f06f1f', // Shibuya
  'le_8137df7bd2e21f2aa50c5ee5f7307907', // District 1
  'le_b5926cf75e11bc1267300883031b5c72', // Budapest
  'le_eb163727917cbba1eea208541a643e74', // Florida
  'le_bd80d53a4b5d3aef9d8a1fabe2feecfc', // San Francisco
  'le_c1a504c62fec63635f320fbf42fe80a6', // Okinawa
  'le_1f920d22a9b1b348f831e0ea883d1e1c', // Prague
  'le_62c14294e6e9c5da9314b2a4e9efadfb', // Hakuba
  'le_2a15efb072c4176909a1421563524eec', // Ulladulla
  'le_dacebfb5d91ee0388e78c9133972e0bf', // Cebu
  'le_071d67ea1ccb598e410737fa52acb911', // Rome City Centre
  'le_45c48cce2e2d7fbdea1afc51c7c6ad26', // Aruba
  'le_d7012f5714b8a6a970f5bd34806267c6', // Scotland
  'le_a1d0c6e83f027327d8461063f4ac58a6', // Costa Rica
  'le_ede7fd615bda28d0440458aca08c92b0', // Cabo San Lucas
  'le_6ea9ab1baa0efb9e19094440c317e21b', // Cambodia
  'le_66339aeaeac3d911af379044c9624005', // Lembongan Island
  'le_2a38a4a9316c49e5a833517c45d31070', // Jamaica
  'le_9f0d4a39afa54dccb4ca9de4296dafbf', // Paros
  'le_f9736cf40a30e0fe71c53004951da2ed', // Dubai
  'le_548026b063092cc5c30e6ea04ccef75c', // Miami
  'le_a5ff5d4b0a0d7b3e4d64147037d8c344', // Whistler
  'le_2a759f617bd1063a2a110eeb0835cc7b', // Hervey Bay
  'le_c51ce410c124a10e0db5e4b97fc2af39', // Bahamas
  'le_e4a86b0d7bf4c46d7d550a92b0b2fcae', // Taormina
  'le_5f0f5e5f33945135b874349cfbed4fb9', // Bodrum
  'le_46b2644cbdf489fac0e2d192212d206d', // Palma de Mallorca
  'le_8e065119c74efe3a47aec8796964cf8b', // Orange
  'le_d0c55943093636296ede7c1ee125928c', // Yarrawonga
  'le_07f9b3b1393c927e3f8e63c2b342cd34', // Ibiza Island
  'le_6acc14464b1fc70161d0731b08edb16f', // The Rocks
  'le_8d4bed9d37dac1e6776dc7d11645a6e3', // Brisbane, QLD (BNE)
  'le_a523426cc585745318d5f6d91a9c0706', // Cowes
  'le_7876acb66640bad41f1e1371ef30c180', // Nouméa
  'le_049d195a9949c99988001e2a78f12062', // Koh Tao
  'le_0dbf135f25773b9d43170343f492572f', // Creswick
  'le_cbca1b9d23a6cab35e2307032afb4ffc', // Macedon Ranges Shire
  'le_ffedf5be3a86e2ee281d54cdc97bc1cf', // Milan
  'le_e1e1e3fc8c15cfa98d47b605f8a7926a', // Vienna
  'le_0c14ffc80188721d493ea4743e9524a9', // Bintan
  'le_88150567b3dbc6ce7f15e1b6731ea027', // Las Vegas Strip
  'le_349f8e8088df63050757dd8be4356216', // Miami Beach
  'le_4409bbb460462b590e765da5e7fa56be', // Krabi Province
  'le_a10c3ce81336de917a2427527f5609cb', // Ko Lanta
  'le_6e9ec3a5f04df981371602cee0f28e18', // Great Ocean Road
  'le_5703de3548ff252d497ed77119eccccf', // Nice
  'le_d6540bf30b8f7a326ddab9ee5f8d2c3a', // Colombo
  'le_23885a3e3ba46d857b6f99febf598019', // Milan
  'le_763e0caafd03b3579826e3e6bc1f3d3f', // Sumba
  'le_7e234336dadf2966e98b4458076126b8', // Bright
  'le_994f13dc1e844f1682b23ddedd6761d6', // Castlemaine
  'le_a93c83bace0f205f5c2f9943b18060e2', // Balearic Islands
  'le_2fdbfd5cc2ea0b97e6b79eb5ca7ba215', // Lancefield
  'le_0f28b5d49b3020afeecd95b4009adf4c', // Palau
  'le_c0c7c76d30bd3dcaefc96f40275bdc0a', // Dominican Republic
  'le_9a1158154dfa42caddbd0694a4e9bdc8', // Egypt
  'le_761194a04b4a4dba71f91e5ae90a3956', // Rio de Janeiro
  'le_5324d3d389537bc820a1e2d02f055dfe', // Banff
  'le_7759927f3f8525abbd95703e8d8b97ad', // Costa del Sol Occidental
  'le_dea184826614d3f4c608731389ed0c74', // Kiama
  'le_6c8349cc7260ae62e3b1396831a8398f', // Cyprus
  'le_7f985230f16c017733cfd8d413419daf', // Curacao
  'le_11040047d832e28ba0cba7689426a641', // Dubrovnik
  'le_bb5c3a7f993b7cb25b2410e212e0386a', // Dunsborough
  'le_47d1e990583c9c67424d369f3414728e', // Puerto Rico
  'le_4ae5b970ea2f37b09c138c60e782560b', // Exmouth
  'le_3bb999121b9cfe9da181aa3d28078e3d', // Waterfront Precinct
  'le_558312eadb08b0c70b6e0f78b5e75a13', // Warragul
  'le_9337b648bca40ec71e59dcbaeb46529c', // Los Cabos
  'le_3b479d2992711d569ed1edc1c9eda1ad', // Munich
  'le_17c884551e0b6e764de15e72e2fa2e33', // Hepburn Shire
  'le_cc97a8205535cd8038f5b2384b2e42ae', // Greater Geelong City
  'le_f643dd6acccb3debf42f4c6df805c67e', // Surf Coast Shire
  'le_4d22dc28a212a9727b1637817a7e9748', // Hokkaido Prefecture
  'le_f9a0324d9edfbcbc619040ddb94a4a61', // Willaura
  'le_b870141093da4f85dad61d23034910af', // Bass Coast Shire
  'le_c94fbd073e07f7f8e207a302010e37f9', // Ararat Rural City
  'le_cedebb6e872f539bef8c3f919874e9d7', // Türkiye
  'le_9766527f2b5d3e95d4a733fcfb77bd7e', // South Africa
  'le_c037c1aec4154dd2f7ce8b82cc36eb38', // Taipei
  'le_093edb52e87f5624ca1441f6db87a2a2', // Tulum
  'le_b59442085644532ef03417a3e5a76437', // Anaheim
  'le_884c0348d6d72650d1597fe7b762ea7a', // Milos
  'le_ad1e3c80f9623c0e75d323e612a457da', // Dublin
  'le_bebd0b4ef70d8bdaf30c447ab37080c4', // Waiheke Island
  'le_bf8229696f7a3bb4700cfddef19fa23f', // Switzerland
  'le_57e3ab51fa2e5b64bce66010014e612e', // Colonia Sant Jordi
  'le_68d30a9594728bc39aa24be94b319d21', // Ireland
  'le_5196906841138f468bb42f9fc849f908', // Bintan Island
  'le_84a3cac633162a1efcc41009c099c53b', // Hakone
  'le_f8f00157b9e7416724a33f0c8e9f6b9d', // Kuala Lumpur (KUL-Kuala Lumpur Intl.)
  'le_2d2f03706b5f59718f42674d39460f24', // Puglia
  'le_2c528879caf8a21a965f91bd692627c5', // Hayman Island, QLD (HIS-Hayman Island Heliport)
  'le_f5b2c7d542d5cc6eecba73128445ef53', // Hong Kong Island
  'le_334467d41d5cf21e234465a1530ba647', // Seville
  'le_7cce53cf90577442771720a370c3c723', // Doha
  'le_4d3ad2b85e5fa9b30b87b0a482a08a58', // Adelaide Hills
  'le_d8e37b628bf4e6231fa51d6f7ddeac5b', // Yamba
  'le_75d4203bbee533f33e5c3d0135bb5710', // Naxos
  'le_1ec4acf07becf61030a7353556614198', // Cape Town
  'le_006f52e9102a8d3be2fe5614f42ba989', // St. Lucia
  'le_0d5bd023a3ee11c7abca5b42a93c4866', // Positano
  'le_6bc770f69fa1f6d6176bd920c409f4e6', // Siem Reap
  'le_c8b81a731259ac5e4cb08bbf7f9cbca2', // Gili Air
  'le_3be1f882b6642c5f29d385324316e8d4', // George Town
  'le_8bd2c3f7fd5b165b470beb1cc83071ab', // Daydream Island
  'le_10decbb58d79ca21df00e40bad5e069e', // Kota Kinabalu District
  'le_da75c0e7d3fdc21799e525181e5c8710', // Manila
  'le_9c8a346cb7a5fac320e5a3d405481026', // Berlin
  'le_9508dfde731fcf464dda8580fc228204', // Canary Islands
  'le_90c34175923a36ab7a5de4b981c1972f', // Glenelg
  'le_991de292e76f74f3c285b3f6d57958d5', // Hayman Island
  'le_2cbdc360315397a173cddb64d9b059df', // El Nido
  'le_e45823afe1e5120cec11fc4c379a0c67', // Menorca
  'le_c8cd63e1bf13c5016881652983fb615a', // San Diego
  'le_3dc4876f3f08201c7c76cb71fa1da439', // Barcelona
  'le_e7cdecbe2d47ac15a15a386ce4d53abc', // Cape Tribulation
  'le_18b91b19f6a289e7708da7f778b2c609', // Kowloon
  'le_8c5cc0fdae1f1087d70c03ae29e5acb9', // Boston
  'le_8873c6e21a043d2f12cb2424c57f56e7', // Busan
  'le_2e656c4e8d03bb4aca4dae8d20d92c8f', // Ginza
  'le_2067e2650cd701ae71c68080f9dbbdc1', // Split
  'le_c81cb23d49ff98e91f8fcf970322d981', // Coral Coast
  'le_ff49d8947eb750cd16b6332239d7d4ec', // Altea
  'le_5c7640152108b9831de6b60d29bd1ca9', // Jakarta
  'le_5812f92450ccaf17275500841c70924a', // Santa Monica
  'le_1b715016be3afe2d4903a8edf6a83901', // Cape Town (CPT-Cape Town Intl.)
  'le_086e1aedd05ee04ce1b2618fccfd603c', // Chicago
  'le_3dc7c0f769f89a5ea943541c69f8fbc7', // Sapporo
  'le_ead623711728935e5dbef58110b05c35', // Yallingup
  'le_ad8f19606da3df6f1d7c2a8a2cde2efc', // Toronto
  'le_6283e5733891c74ad2926efa270f0a98', // Tamborine Mountain
  'le_558f19385bf2dc5c4577c22b392df60d', // Auckland Region
  'le_063cec3d11bcef5e1b9cc9531aaeae87', // Kerala
  'le_564f471df2f0e7ca4be37b91b7223114', // Playa del Carmen
  'le_b7ee6f5f9aa5cd17ca1aea43ce848496', // Guangzhou
  'le_950a4152c2b4aa3ad78bdd6b366cc179', // Málaga
  'le_d1fe173d08e959397adf34b1d77e88d7', // Iceland
  'le_83dc55aeb13cc9f621dcbaa80304d506', // Terrigal
  'le_3574aff5de7bf1fe29802a407eb67fbb', // Forster
  'le_e646a41cf0fc231116f31d0a07140bf9', // Thredbo
  'le_ffe29c71e4cd3f141d8d80f82cbe4e72', // Batam
  'le_741dabd2314255432d480f44acb1a55e', // Docklands
  'le_2654c9306252c0eb8539d5af2d5c4d0b', // Brucoli
  'le_f95ec3de395b4bce25b39ef6138da871', // Udaipur
  'le_04720d98ab3dcbc0cb76d6f1e6bbd6eb', // Chania
  'le_0c26938e018bf10ea0de7aa33c3d5979', // Gili Trawangan
  'le_03d85f4231be1b592e525a193c48ef16', // Cornwall
  'le_6941d4809bf42c9cd6b5a79f36332fe0', // Beijing
  'le_2ea1202aed1e0ce30d41be4919b0cc99', // Caloundra
  'le_29bc9158e3be94f926038ab164cdcb30', // Jeju Island
  'le_4603a288c7680ffd36305dcea72755d2', // Tai Koo Shing
  'le_7b1f750112342832bd4ad29287b6865c', // Zakynthos
  'le_dbfc08e9f26d57a6d7a7259655fdf3ce', // Riviera Maya
  'le_804ee2ff17a093f6f1bd8909f2bf6f49', // Penida Island
  'le_9fb7b0295b84b48d354f17d158298ea9', // Berry
  'le_737734c0874b6b308ddbc78d17d3ccae', // Palma de Mallorca (PMI)
  'le_9608332628503fd84e029ce2350c066a', // Montreal
  'le_7553e94d39fd4649ff75386a83ed3789', // Valencia
  'le_261715927602c2cfb85965618558b697', // Greek Islands
  'le_8f14e45fceea167a5a36dedd4bea2543', // Antigua and Barbuda
  'le_7e8750d4a701596732953c160d2ae096', // Lagos
  'le_d7a6a41890055c5daaedc1445ca45a2d', // South Bank
  'le_a2557a7b2e94197ff767970b67041697', // United Arab Emirates
  'le_4c5bde74a8f110656874902f07378009', // Tunisia
  'le_3cf4b383221cac520fb5aa9eb5572f93', // Nice (NCE-Cote d'Azur)
  'le_b02e6098244d867ef9e033afaf097d81', // Africa
  'le_38af86134b65d0f10fe33d30dd76442e', // Taiwan
  'le_aab281b2afa3f7615e22cb1910ce864d', // Cam Lam
  'le_d5600c67f03e338e56a8ade3786e243e', // Istanbul
  'le_7a561ab1771837fcf8105fff8c091425', // Sanur Kauh
  'le_73e3d45279e760d4f0f1642801549015', // Margaret River Wine Region
  'le_6600c61f0d6854ccc7da5db19aa7abb8', // Nusa Penida
  'le_91301df5bc0de6495a75bfeb734667c5', // Bath
  'le_29adf4cd5ea594204b3ef07197b0a05f', // Mollymook
  'le_b0f56a6c6934e8cfd22376a62487864d', // Corsica
  'le_fee6ef7598836a6b8e995969019c6472', // Kefalonia
  'le_ada6644724adf11bf9ed5c6ed5e82fc0', // Bang Kao
  'le_2b323d6eb28422cef49b266557dd31ad', // Sharm El Sheikh
  'le_fd8398682ff1c73f3a3bc98dbcfc0565', // Gili Islands
  'le_06f45eefea8a4459fe1c0eab0365da91', // Amed
  'le_aeba890c55e24d35f0a34f07aeaa4956', // Lake Garda
  'le_33074f4e0696b19de101d8d1d71f0708', // Sa Pa
  'le_37d34177c59d0ed357f8af3e8927e6d8', // Bondi Beach
  'le_fe332db6e17e429d0b2ecafc8a0e3990', // Mumbai
  'le_3e86a4598df00698360b8a9b6d16dd2e', // Reykjavik
  'le_045117b0e0a11a242b9765e79cbf113f', // Tonga
  'le_39c4c0a45681f21cead1b7004d1a67ce', // Seattle
  'le_d9c2ac911a2c9acecf60ee12f1e03e2e', // Ibiza (IBZ)
  'le_e48e763ff50bba8534f7df786aba14e6', // Province of Rome
  'le_4c1aed5cf6e57f56279ce744d8b4758c', // Hepburn Springs
  'le_e7218f38ef3fdf8a055b7ff9611b75fe', // Ko Yao Noi
  'le_64a191e76924fd88a84a50726374877c', // Hong Kong China Ferry Terminal
  'le_4cfbc51c4d39c53146a0064ca373ddef', // Warrnambool
  'le_ac00d8d42828f07427af0c7091bb6ad4', // New Orleans
  'le_ff0587bab4153d3caa707fb81c141317', // Auckland Central Business District
  'le_906d9e9b2accf74cc84f59d1f824d596', // Lamai
  'le_f8f5161cf94df05793592f5fab95138b', // Taupō
  'le_cdf1035c34ec380218a8cc9a43d438f9', // Jaipur
  'le_44012e792781772d8795acf27fabed2f', // Ko Phi Phi
  'le_60ce36723c17bbac504f2ef4c8a46995', // Monopoli
  'le_ec424cb3445fe41024ee2cfd2be7edbf', // Kos
  'le_24fd2d1c4a4e499197afccbee4d2cb8c', // Sunset Road
  'le_182438e09eb1ae0567c5773c0a566da2', // Castaway Island
  'le_5d50d22735a7469266aab23fd8aeb536', // Katoomba
  'le_308ad6c7eb97770bfa65672db3327cb9', // Coles Bay
  'le_1b63eb116968597c8105aa24c3fcfd0a', // Cefalù
  'le_a5304bb9915d3c24097c6ec34d939577', // Furano
  'le_9d25d273b9acd6e734ae905793a250e7', // San Sebastián
  'le_8373aeb2b7e740d5110761758058da12', // Paris City Center
  'le_0b296fabc2a8354c11a2bbefbff375d9', // Koh Lipe
  'le_06d5ae105ea1bea4d800bc96491876e9', // Manchester
  'le_b8ccf4b605ccaf525b24a7e234167181', // Cam Nam Island
  'le_7c765e60c6333f148ed2b70b3c09e6f2', // K'gari (Fraser Island)
  'le_8712c3607f9452c9eb2fb7ffa9a826b0', // Malolo Island
  'le_1004543e9bd32a1ebe670c004ee0e266', // Nozawaonsen
  'le_0decd736e9cee73e63418003b47d7d56', // West Hollywood
  'le_dc665b1ed5a43d812ce10458bf4c4cf3', // Agia Galini
  'le_6c4f52492806d056897837fe6253eb82', // Nashville
  'le_0c042cf235e9038e23d14bb0d8f58a21', // Batu Bolong
  'le_3fdcd026e23780118b8b9558017d01ce', // Puerto Vallarta
  'le_747d3443e319a22747fbb873e8b2f9f2', // Ho Chi Minh City
  'le_0f3d014eead934bbdbacb62a01dc4831', // Hurghada
  'le_5bf378a0628e9dd314d754e7621c2840', // Lefkada
  'le_2f28ba4afb1eb0395ecf47ec4c736d08', // Johor
  'le_6512bd43d9caa6e02c990b0a82652dca', // Austria
  'le_9a8b3a74384a79e153bf0bc17029cf3d', // Mission Beach
  'le_4038d29b84dbde416cfa738db297acef', // Albany
  'le_6a61d423d02a1c56250dc23ae7ff12f3', // Falls Creek
  'le_c381dc78e35cd83fa1c4e916b1974a6c', // Green Island
  'le_19cd9fce4f533a9340ef89cb77d9a4f8', // Cam Ranh
  'le_49ae49a23f67c759bf4fc791ba842aa2', // Abu Dhabi
  'le_f96f9be4a7f4fa8ad6803378e0529ebc', // Perisher Valley
  'le_bacc08ba2a5cdf071b177286ee4ad2b8', // Cable Beach
  'le_a0c42e805270747990ddfe75e5780aad', // Ksamil
  'le_11af9c46e6a728505799872b487aace1', // Hvar
  'le_3988c7f88ebcb58c6ce932b957b6f332', // Norfolk Island
  'le_8d7d0b76e736c6b18d9b8ffbc3192255', // Dien Duong
  'le_2d752ca077fe303af53833762efc8b2a', // Madeira Region
  'le_71eee742e4c6e094e6af364597af3f05', // Coron
  'le_15d38e2f21c1bcfa793ae7b17c83e85d', // Oia
  'le_c9cb796b17ea805f9e98f2531b0068ea', // Naples
  'le_2fb7b79b06036c1aae327db90df4ac6e', // Myrtle Beach
  'le_c01ca642daebb0b11e22f9b92dafa065', // Tweed Heads
  'le_344d81958569ba7de0c4ded7ae3cb201', // Bukit Bintang
  'le_a10464c8ae900ae18af996c07037083a', // Tenerife
  'le_9819bda47e4a8234d65c1385a8a9e0ad', // McLaren Vale
  'le_7c7c7d7efbe982a79a483f02df5e1c6a', // Galle
  'le_ea5d2f1c4608232e07d3aa3d998e5135', // Germany
  'le_6f90e60431b4709ab6cd0349f0348d46', // Umalas
  'le_f6a8731ce4df563918db39eb1990b5ab', // Coogee
  'le_9ad97add7f3d9f29cd262159d4540c96', // Hanmer Springs
  'le_b816159b242ae0f8a2035d213ee84f2a', // Jervis Bay
  'le_5bcb499e7e7dd8d87651fcb7fcb8da93', // Bohol
  'le_82d3149fc1f8d2305e7c6d56a6c5689d', // Capri
  'le_e3b16a9441a8fe2ad88f05c4055f3de0', // Fortitude Valley
  'le_341f73f21eb3842764224578c161e2cc', // Lake Tekapo
  'le_2c77b7d819c41860980003fe4d8a9b4b', // Sukhumvit
  'le_30122d761077ba3b63312a042f776502', // Pejarakan
  'le_091bc5440296cc0e41dd60ce22fbaf88', // Coolum Beach
  'le_3d78a7e47ddc7693b56523b7c691b4ce', // Maleny
  'le_4d484eb02555ea38ed91f75927d21371', // Naousa
  'le_80e4c54699b5b8cf8c67dd496909fceb', // Lake District National Park
  'le_18926ceff2a3506fc643f616c7d2167b', // Stanthorpe
  'le_af9734fb3f87897dfd002ff498591856', // Albury
  'le_ec220fe8e94ec5540d26ff69a283399b', // Dhonakulhi
  'le_9b01a4ac97dbb35deafe943914d4c569', // Phuket (city)
  'le_d47bb339212ddfab0fadd99d492a5fc3', // Phuket
  'le_b21d2f86beb192143a04671ac93bfd00', // Bintan
  'le_84ddc9bef8fa95d694fbfbec0cb659f0', // Palm Springs
  'le_12140997310043fd0d621e1d4a9896cb', // Dunedin
  'le_84bf0d9e9b2c343157639c0298bdbb4d', // Shoal Bay
  'le_7cba87f571a31baf11325f462fbdcf14', // Toowoomba
  'le_3014c0b05519f41029625d48954874ce', // Healesville
  'le_6f4922f45568161a8cdf4ad2299f6d23', // Belize
  'le_624b9af3663101486043a860eadf3738', // Moorea
  'le_acf666483bc8723fae7feda6f6a9cb7a', // Zermatt
  'le_8a0655752c51376981ea11c529e4c7d8', // Lapland
  'le_25f522d2e0dcbde772608d3453634e68', // Myeong-dong
  'le_da1726aa3f060ae548a37763b9c61d2d', // New Delhi
  'le_7e8a64fe3c64379a9c7a501883265562', // Kedewatan
  'le_7f29a05e04d4a2832e0122eb3f3dd8e6', // Montville
  'le_fd25138f4f50e43369a042a48a834156', // Quy Nhon
  'le_caac0ce8cdd2f8360dd75c12e42ccb48', // Fethiye
  'le_8721ad5342e96ad0cfcf2af6e48ca466', // Kirra
  'le_1301962d8b7bd03fffaa27119aa7fc2b', // Parramatta
  'le_705c9b1ec504747f6b0410cdd9b11d84', // Niagara Falls
  'le_589de5911c01c3c6735aa7acfbbb9336', // Mandurah
  'le_8edd72158ccd2a879f79cb2538568fdc', // Glasgow
  'le_c00849c0e8d0541ede8033ef6ffd1b02', // Rusutsu
  'le_e5f5e9affb5b0cbb86837b7336575fa5', // Perth, WA (PER)
  'le_e00da03b685a0dd18fb6a08af0923de0', // Oman
  'le_9872ed9fc22fc182d371c3e9ed316094', // U.S. Virgin Islands
  'le_bb44c2e24438b59f0d2109fec67f6b20', // Jindabyne
  'le_903c81a28319cc21d19c566dcb8ddefe', // Malacca
  'le_6a9aeddfc689c1d0e3b9ccc3ab651bc5', // Lanzarote
  'le_609ef4cc3fdcafee66c2de956d3f07ca', // Cannes
  'le_0a4ef1b77fc3f20f80a68e5f7e4c6084', // North Goa
  'le_2f3d9b534d726b2d921451852adedb0c', // Apollo Bay
  'le_750582f2783b41ee389c0553ba80c758', // Balapitiya
  'le_62893a1643f41dad1491df49cf7bee63', // Myoko
  'le_85a47dfd590a335a43cfa3d0d19b2349', // Sidemen
  'le_690cdf6a631d05d42c4af81fc9f5bcf6', // Cairo
  'le_418c36be2f3abf6276eb882dd45bf400', // Ella
  'le_6f68e7f033a4a87673bc53a00c9aad59', // Duong To
  'le_d902c3ce47124c66ce615d5ad9ba304f', // York
  'le_d827f12e35eae370ba9c65b7f6026695', // Merimbula
  'le_b925d57b5ccdf1b1776d6fa455b538ef', // Melbourne Airport
  'le_cc90a80444fe691b7f8c50cf75d942f6', // French Riviera
  'le_fccb3cdc9acc14a6e70a12f74560c026', // Bari
  'le_ca1d3153a1cf0ed998d4879fbb50d9ab', // Mahé Island
  'le_4b939fcefc86c72e8f298ab2831c6640', // Batemans Bay
  'le_71168608a00480065deeb4e02064455b', // Ko Pha-ngan
  'le_735fae61e2b0f29cae18117c99c2fa59', // Hamilton
  'le_85fc37b18c57097425b52fc7afbb6969', // Bologna
  'le_552433976d1dec978e46a18ea7166fd1', // Kartika Plaza
  'le_7a070d903651436812bc410060c33342', // Mexico City
  'le_0763a9da1cee4722c66b2c6315b3e9c7', // Shenzhen
  'le_adda8fe911a630ef9e68e6ac588f851e', // Kemenuh
  'le_535a6d5116b9aea22c366ef0b170bffe', // Old Quarter
  'le_981ac243503d79551fbce2b9323ab287', // The Challenge Phangan
  'le_413cb7042e54f54bdfbd64d25241b307', // Calgary
  'le_7f279a6c92116f32e9159d797205fb63', // Candi Dasa
  'le_92678f890f6d9fe36d2d50aa086b34de', // Nozawa Onsen Snow Resort
  'le_cdd0500dc0ef6682fa6ec6d2e6b577c4', // Tokyo
  'le_562665876813fa22c782a16245091b88', // Alice Springs
  'le_950c8208d79a915166663ce1dab61d9d', // Kauai
  'le_4ea6a546c19499318091a9df40a13181', // Palermo
  'le_af70cb26d4df4761213875bb59a82e88', // Baa Atoll
  'le_6a242c0902d0c2c1a0ad7166100d3536', // Chania
  'le_6c524f9d5d7027454a783c841250ba71', // Alicante
  'le_e7c7f26e208f2cd121779b810d9e9096', // Brussels
  'le_319e518a55a79987ddb386350b1d1fd2', // Papeete (PPT-Tahiti Faaa Intl.)
  'le_f074f2903f7bf3f071789f53418daf9b', // Kandy
  'le_8a9248ede4fe7905c206008baabe9d36', // Montego Bay
  'le_32fdab6559cdfa4f167f8c31b9199643', // Te Anau
  'le_032a01d83345f23883c98c540ff32fe7', // North Sydney
  'le_b9bb39720dd1e96de6f0323b44c054b6', // Desaru
  'le_d93ed5b6db83be78efb0d05ae420158e', // Dubbo
  'le_b3f445b0ff5a783ec652cdf8e669a9bf', // Lakes Entrance
  'le_7b868a48abc1244819063d3a282a76fd', // Hue
])
